export const groupByDay = (arr, group_field = 'created_at') => {
    return arr.reduce((acc, item) => {
        const day = getDayKey(item[group_field]);
        if (!acc[day]) acc[day] = [];
        acc[day].push(item);
        return acc;
    }, {});
};

const getDayKey = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};